import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/app_logo_white.png")